module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    staticClass: "bodymatter",
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h1', {
    staticClass: "chapter_fm1",
    attrs: {
      "id": "c04"
    }
  }, [_c('span', {
    staticClass: "chapter_fm1"
  }, [_vm._v("c. 1300 BCE")])]), _vm._v(" "), _c('h1', {
    staticClass: "chapter"
  }, [_vm._v("Iron Smelting")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("The Iron Age definitively replaced the "), _c('strong', [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c02"
    }
  }, [_vm._v("Bronze")])]), _vm._v(" Age, so you would assume that the newly available iron must have been clearly superior. Not so—good bronze was harder and much more corrosion-resistant. However, major disturbances and population movements in the Mediterranean and Near East around 1300 BCE may have disrupted the metal trade that bronze-working depended on. Iron ore was much easier to come by, but higher-temperature furnaces were needed to smelt it, and these often depended on forced air. Iron production was thus, sometimes, a seasonal event, with furnaces built to take advantage of monsoons and other dependable winds. Objects made of iron from before 1300 BCE are known but uncommon, and many of these are not even from our own planet—produced from solid nickel-iron meteorites, they must have been very valuable objects indeed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Given a chance, iron will react with oxygen to produce rust (iron oxide), and smelting iron ore is basically the reverse process. The early iron-smelting device, a clay or stone furnace with air inlet tubes, was called a "), _c('em', [_vm._v("bloomery")]), _vm._v(". Charcoal and iron ore were heated, producing a lump of crude smelted iron (the "), _c('em', [_vm._v("bloom")]), _vm._v(") in the bottom of the furnace. This was a laborious process, since the bloom needed further heating, and lumps of impurities had to be beaten out before it could be useful. Still, iron technology spread rapidly, and it seems to have been discovered independently in several locations, including India and sub-Saharan Africa. Ancient wind-driven iron furnaces evolved into the modern blast furnace—in which ore is fed in continuously from the top and has its oxygen stripped away by contact with carbon monoxide gas of ferocious temperatures—as early as the first or second century BCE in China.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Iron’s properties change dramatically depending on what is mixed into it. Careful addition of some of the charcoal’s carbon produces steel—a superior metal in every way—but this was a job for experienced craftsmen: too little carbon produced soft wrought iron, while too much carbon yielded a very hard metal that is too brittle for most uses. Now, the varieties of iron alloys and steels in modern metallurgy are almost too many to count.")]), _vm._v(" "), _c('p', {
    staticClass: "seealso"
  }, [_c('strong', [_vm._v("SEE ALSO")]), _vm._v(" "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c02"
    }
  }, [_vm._v("Bronze (c. 3300 BCE), Viking Steel (c. 800)")]), _vm._v(", "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c22",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("De Re Metallica")]), _vm._v(" (1556)")]), _vm._v(", "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aluminum (1886)")]), _vm._v(", "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stainless Steel (1912)")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('div', {
    staticClass: "dis_img"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/021.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A modern blast furnace can produce molten iron on a scale that ancient craftsmen could only dream of. But by any route, ironworking has always been a very energy-intensive process.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e79e0ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/c04.vue
// module id = 87
// module chunks = 0